<template>
  <div>
    <van-nav-bar title="落箱凭证" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <van-search v-model="boxno" show-action label="箱号" placeholder="请输入搜索箱号" @search="onSearch"></van-search>
    <div v-for="(item, index) in orderData" :key="index" @click="goBillInfo(item.id)">
      <van-cell value="内容" is-link>
        <template #title>
          <span class="custom-title">{{ item.boxno }}</span>
          进
          <van-tag type="danger" v-if="item.in_status=='司机提交'">{{ item.in_status }}</van-tag>
          <van-tag type="success" v-if="item.in_status=='道口提交' || item.in_status=='叉车提交'">{{ item.in_status }}</van-tag>
          出
          <van-tag type="danger" v-if="item.out_status=='司机提交'">{{ item.out_status }}</van-tag>
          <van-tag type="success" v-if="item.out_status=='道口提交' || item.out_status=='叉车提交'">{{
              item.out_status
            }}
          </van-tag>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Search, List} from 'vant';

Vue.use(Search);
Vue.use(List);
import {Cell, CellGroup} from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);

export default {
  data() {
    return {
      boxno: '',
      orderData: [],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push({path: "/container-yard/home"});
    },
    onSearch(val) {
      this.getList(val);
    },
    //获取列表
    getList(boxno) {
      let querystring = require('querystring');
      this.$api.post('wx/container-yard/billList',
          querystring.stringify({
            tel: localStorage.getItem("tel"),
            boxno: boxno,
            type: '落箱凭证',
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.orderData = data.data.data;
        } else {
          Dialog.alert({
            message: data.data.msg,
          }).then(() => {

          });
        }
      }).catch(err => {
        console.log(err);
      })
    },
    goBillInfo(id) {
      this.$router.push({
        path: "/container-yard/billInfo/" + id
      });
    },
  },
  mounted() {
    this.getList();
  }
}
</script>

<style scoped>
.lineItem {
  background: #f5f5f5;
  color: #666666;
  font-size: .38rem;
}

.lineItem_list {
  height: 5vh;
  background: white;
  margin-bottom: 0.5vh;
  margin-top: 0.5vh;
}

.lineItem_list > div {
  margin: 0.5vh auto;
  padding: 0 2vw;
  display: -webkit-flex;
  flex-direction: column;
}

.lineItem_list > .lineItem_head {
  height: 5vh;
  padding: 0 2vw;
  justify-content: space-around;
}

.lineItem_head > div {
  display: -webkit-flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/container-yard/billList.vue